import { render, staticRenderFns } from "./NavigationItem.vue?vue&type=template&id=2dead316&scoped=true&"
import script from "./NavigationItem.vue?vue&type=script&lang=ts&"
export * from "./NavigationItem.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationItem.vue?vue&type=style&index=0&id=2dead316&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dead316",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VListItem,VListItemContent,VListItemTitle})
